import React, { useState } from "react";
import "./App.css";
import ImageCarousel from "./ImageCarousel/ImageCarousel";
import { Swiper, SwiperSlide } from "swiper/react";
import { ImageModal } from "./ImageModal/ImageModal";

// Import your logo image
import logo from "./wild-cats-logo.png";
import image1 from "./assets/images/1.png";
import image2 from "./assets/images/2.png";
import image3 from "./assets/images/3.png";
import image4 from "./assets/images/4.png";
import image5 from "./assets/images/5.png";
import image6 from "./assets/images/6.png";
import image7 from "./assets/images/7.png";
import image8 from "./assets/images/8.png";

const App = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImageId, setSelectedImageId] = useState(0);

    const onSelectImageId = (id) => {
        setSelectedImageId(id);
    };

    const carouselImages = [
        image1,
        image2,
        image3,
        image4,
        image5,
        image6,
        image7,
        image8,
    ];

    return (
        <div className="App">
            <header className="header">
                <img src={logo} alt="Wild Cats Dev Logo" className="logo" />
                <h1 className="company-name">Wild Cats Dev</h1>
            </header>

            <section className="product-info">
                <h2>Synthetic YOLO Dataset Generator</h2>
                <p>
                    Generate synthetic YOLO datasets for object detection and
                    segmentation—fast, customizable, no coding.
                </p>

                <ImageCarousel
                    images={carouselImages}
                    onSelect={onSelectImageId}
                    onOpen={() => setIsModalOpen(true)}
                />

                <p>
                    The Synthetic YOLO Dataset Generator is a powerful Unity
                    tool designed to create high-quality synthetic datasets for
                    training computer vision models—specifically object
                    detection and segmentation tasks using the YOLO format.
                </p>
                <p>
                    This package enables you to generate thousands of labeled
                    images directly within the Unity Editor, using fully
                    customizable prefabs and intuitive inspector settings. No
                    coding is required.
                </p>

                <h3>🔧 Key Capabilities:</h3>
                <ul>
                    <li>
                        Generate datasets for YOLO object detection and polygon
                        segmentation
                    </li>
                    <li>
                        Add post-processing effects (Depth of Field, Motion
                        Blur, Color Grading, etc.)
                    </li>
                    <li>
                        Use randomized lighting, object rotation across custom
                        axes, and random cropping
                    </li>
                    <li>
                        Export structured datasets ready for training
                        (train/val/test split)
                    </li>
                    <li>
                        Instantly preview labeled results with the included
                        "labeled" folder
                    </li>
                </ul>

                <h3>⚙️ Customization:</h3>
                <ul>
                    <li>Supports any Unity 3D object with a renderer</li>
                    <li>
                        Fully configurable via the Inspector (camera setup,
                        lighting, resolution, output path, etc.)
                    </li>
                    <li>
                        Create and save prefab variants for different use cases
                        (vehicles, characters, tools, etc.)
                    </li>
                    <li>Works with YOLOv8-YOLOv12 formats</li>
                </ul>

                <h3>🎯 Use Cases:</h3>
                <ul>
                    <li>
                        AI training for autonomous vehicles, robotics, security,
                        and AR
                    </li>
                    <li>
                        Game developers prototyping ML-driven gameplay features
                    </li>
                    <li>
                        Researchers generating diverse computer vision datasets
                        without manual labeling
                    </li>
                </ul>

                <p>
                    Whether you're building a real-time object detector or
                    training a deep learning model, this tool helps you
                    accelerate your data pipeline—right inside Unity.
                </p>

                <h3>📝 Key Features:</h3>
                <ul>
                    <li>
                        ✅ Synthetic Dataset Generation: Create labeled datasets
                        for YOLO object detection and segmentation tasks.
                    </li>
                    <li>
                        🖼️ Built-in Image Annotation: Automatically generates
                        bounding boxes and polygon masks in YOLO format.
                    </li>
                    <li>
                        🎞️ Post-Processing Effects: Apply realistic effects like
                        Depth of Field, Motion Blur, Color Grading, and more to
                        boost dataset variety.
                    </li>
                    <li>
                        🎯 Object Rotation & Augmentation: Generate data with
                        360° object rotations across custom axes to improve
                        model generalization.
                    </li>
                    <li>
                        🌗 Lighting Randomization: Vary scene lighting
                        conditions dynamically for robustness in diverse
                        environments.
                    </li>
                    <li>
                        📂 Clean Folder Output: Exports images, YOLO .txt
                        labels, and visual "labeled" previews in structured
                        folders (train/val/test).
                    </li>
                    <li>
                        🛠️ No Coding Required: Use preconfigured prefabs and
                        editor-friendly scripts—just drag, drop, and generate.
                    </li>
                    <li>
                        📐 Custom Resolution & Split Control: Easily configure
                        image size, dataset size, and train/val/test
                        percentages.
                    </li>
                    <li>
                        🔄 Resettable Settings: Custom inspector UI with a
                        one-click Reset Settings button.
                    </li>
                    <li>
                        🧪 Demo Scene Included: Quickly test features and
                        explore setup examples with the included demo scene and
                        assets.
                    </li>
                </ul>

                <h3>📧 Contact:</h3>
                <p>
                    Email for support and feedback:{" "}
                    <a href="mailto:wildcatsdev@gmail.com">
                        wildcatsdev@gmail.com
                    </a>
                </p>

                <h3>🔗 Get It Now:</h3>
                <a
                    href="https://assetstore.unity.com/packages/slug/325115"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                >
                    Go to Asset Store
                </a>
            </section>

            <ImageModal
                open={isModalOpen}
                handleClose={() => {
                    setIsModalOpen(false);
                }}
                image={carouselImages[selectedImageId]}
                imageId={selectedImageId}
            />
        </div>
    );
};

export default App;
